var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosePlansButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116.19,
    height: 101.3,
    viewBox: "0 0 116.19 101.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(0 2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4017",
    "data-name": "Path 4017",
    d: "M55.888,0H18.629L0,32.267,18.629,64.533H55.888L74.517,32.267Z",
    transform: "translate(58.137 96.8) rotate(-120)",
    fill: "#ed3a72",
    stroke: "#ed3a72",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ion-md-arrow-dropright",
    "data-name": "Icon ion-md-arrow-dropright",
    d: "M0,0,16.352,20.227,0,40.453Z",
    transform: "translate(16.352 68.626) rotate(-180)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-x",
    "data-name": "Icon feather-x",
    d: "M40.44,9,9,46.653M9,9,40.44,46.653",
    transform: "translate(42.732 19.173)",
    fill: "none",
    stroke: "#fef587",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePlansButton);
export default __webpack_public_path__ + "static/media/close-plans-button.b0dddd333e135caa0115b1250a5a385c.svg";
export { ForwardRef as ReactComponent };